const form = {
    postFailCallback: null,
    post: function (url, formId, updateString, postDoneCallback, postFailCallback) {
        // エラーメッセージをすべて排除
        $(".error__message").remove();
        $(".error").removeClass("error");

        const paramList = new FormData();
        const targetForm = $(formId);
        $(targetForm)
            .find("input, select, textarea")
            .map(function () {
                // ラジオボタンだったらここではスルー
                if ($(this).attr("type") === "radio") {
                    return;
                }
                // チェックボックスだったら、チェックが入っているか確認
                if ($(this).attr("type") === "checkbox") {
                    if (!$(this).prop("checked")) {
                        return;
                    }
                }

                const name = $(this).attr("name");
                paramList.append(name, $(this).val());
            });
        let names = [];
        $(targetForm)
            .find('input[type="radio"]')
            .map(function () {
                names.push($(this).attr("name"));
                // const name = $(this).attr("name");
                // paramList.append(name, $(this).val());
            });
        // 重複削除
        names = [...new Set(names)];
        names.map(function (name) {
            const checkedRadio = $("input[name='" + name + "']:checked");
            if (checkedRadio.length) {
                paramList.append(name, checkedRadio.val());
                return;
            }
            paramList.append(name, "");
        });
        if (typeof postDoneCallback !== "function") {
            postDoneCallback = post.postDone;
        }

        if (typeof postFailCallback === "function") {
            form.postFailCallback = postFailCallback;
        } else {
            form.postFailCallback = null;
        }

        post.postAjaxData(url, paramList, updateString, postDoneCallback, form.postFail, null);
    },

    // POSTが完了した
    // 通常
    postDone: function (results) {},

    // 失敗。バリデーション失敗のときにも発生
    postFail: function (jqXHR, textStatus, errorThrown) {
        // エラーの表示する。
        for (const key in jqXHR["responseJSON"]["errors"]) {
            targetKey = key.replace(".", "");

            // 表示位置を取得する。
            if ($(".js-" + targetKey + "-error").length !== 0) {
                $(".js-" + targetKey + "-error").append(
                    '<span class="error__message">' + jqXHR["responseJSON"]["errors"][key] + "</span>"
                );
            } else {
                $(".js-" + targetKey).append(
                    '<span class="error__message">' + jqXHR["responseJSON"]["errors"][key] + "</span>"
                );
            }

            $(".js-" + targetKey).addClass("error");
        }

        const errorSubmit = $(".js-errorSubmit");
        if (errorSubmit.length !== 0) {
            errorSubmit.append(
                '<div class="error__message error__message--submit">入力内容に誤りがあります<br />各項目をご確認ください</div>'
            );
        }

        form.activateButtons([".js-submit", ".js-email-change-submit"]);

        if (typeof form.postFailCallback === "function") {
            form.postFailCallback(jqXHR, textStatus, errorThrown);
        }
    },

    // ボタンを活性化
    activateButtons: function (buttonSelectors) {
        buttonSelectors.forEach((selector) => {
            $(selector).prop("disabled", false);
        });
    },

    // ボタンを非活性化
    disableButtons: function (buttonSelector) {
        const selectors = Array.isArray(buttonSelector) ? buttonSelector : [buttonSelector];
        selectors.forEach((selector) => {
            $(selector).prop("disabled", true);
        });
    }
};

window.form = form;
